module.exports = __webpack_public_path__ + "img/63_10.15db25d9.png";